import { useCallback, useState } from "react";
import _ from "lodash";
import { Autocomplete, AutocompleteItem } from "@nextui-org/react";
import { useLectures } from "../../lectures/hooks/useLectures";

function LecturesSelection({ setLecturesIds, lecturesIds, courseId }) {
    const [searchValue, setSearchValue] = useState("");
    const { lectures, isPending } = useLectures({
        courseId,
        // perPage: 6,
        searchValue,
    });

    const handleChange = (value) => {
        const newIds = [...lecturesIds];
        const index = newIds.indexOf(value);
        if (index === -1) {
            newIds.push(value);
        } else {
            newIds.splice(index, 1);
        }
        setLecturesIds(newIds);
    };

    const onSearchChange = useCallback(
        _.debounce((value) => {
            if (value.trim() || value === "") {
                setSearchValue(value);
            }
        }, 500),
        [setSearchValue]
    );

    return (
        <div className="w-4/5 pt-5 lg:w-2/5">
            <p className="py-3 text-lg font-medium text-primary-color-primary">
                المحاضره :
            </p>

            <Autocomplete
                placeholder="بحث"
                size="lg"
                fullWidth={true}
                className="text-right"
                labelPlacement="outside"
                variant="underlined"
                aria-label="أختيار اسم المحاضره"
                isLoading={isPending}
                search={true}
                multiple={true}
                onSelectionChange={handleChange}
                onValueChange={(value) => {
                    onSearchChange(value);
                }}
            >
                {!isPending &&
                    lectures?.data?.map((lecture) => (
                        <AutocompleteItem
                            key={lecture.id}
                            value={lecture.id}
                            textValue={lecture.attributes.name}
                            className={`flex w-full gap-3 py-3`}
                        >
                            <div>
                                <p className="font-medium text-blue-color-primary">
                                    #{lecture.id}
                                </p>
                                <span>{lecture.attributes.name}</span>
                            </div>
                        </AutocompleteItem>
                    ))}
            </Autocomplete>
        </div>
    );
}

export default LecturesSelection;
